
import { useState } from "react";
import persian from "react-date-object/calendars/persian";
import { DateObject } from "react-multi-date-picker";
import "react-multi-date-picker/styles/backgrounds/bg-dark.css";
import { useNavigate } from "react-router-dom";
import { api } from "../../../../utils/api";
import { LoginHelper } from "../../../../utils/LoginHelper";
import EditorFieldSection from "../../../common/editor/EditorFieldSection";
import EditorFormShell from "../../../common/editor/EditorFormShell";
import FieldDescription from "./FieldDescription";
import FieldImage from "./FieldImage";
import FieldPrice from "./FieldPrice";
import FieldStart from "./FieldStart";
import FieldExpertise from "./FieldExpertise";
import FieldTitle from "./FieldTitle";


export default function Form({ isDesktop }) {
	const navigate = useNavigate();
	const [title, setTitle] = useState("");
	const [description, setDescription] = useState("");
	const [price, setPrice] = useState("");
	const [image, setImage] = useState(null);
	const [startDatetime, setStartDatetime] = useState(new DateObject({ calendar: persian }));
	const [expertiseIds, setExpertiseIds] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');

	const handleTitleChange = (e) => {
		setTitle(e.target.value);
	}

	const handleDescriptionChange = (e) => {
		setDescription(e.target.value);
	}

	const handlePriceChange = (e) => {
		setPrice(e.target.value);
	}

	const handleImageChange = (e) => {
		setImage(e.target.files[0]);
	}

	const handleStartDatetimeChange = (value) => {
		setStartDatetime(value);
	}

	const handleExpertiseChange = (ids) => {
		setExpertiseIds(ids);
	}

	const handleSubmit = () => {
		if (isLoading) return;
		setIsLoading(true);
		api.webinarAdd({
			token: LoginHelper.getToken(),
			title: title,
			description: description,
			price: price,
			image_file: image,
			start_datetime: startDatetime.toDate().toISOString(),
			expertise_ids: JSON.stringify(expertiseIds),
		}).then((res) => {
			setIsLoading(false);
			const webinarId = res.id;
			navigate('/webinar_detail/' + webinarId + '/');
		}).catch((err) => {
			setIsLoading(false);
			if (err && err.data) {
				setErrorMessage(err.data.message);
			}
		});
	}

	return (
		<EditorFormShell
			title="ساخت وبینار"
			subtitle="عنوان، زمان شروع، قیمت و تصویر وبینار را وارد کنید."
			errorMessage={errorMessage}
			onSubmit={handleSubmit}
			isLoading={isLoading}
			submitLabel="انتشار وبینار"
		>
			<EditorFieldSection title="اطلاعات اصلی" description="عنوان، توضیحات و قیمت وبینار">
				<FieldTitle title={title} onChange={handleTitleChange} />
				<FieldDescription description={description} onChange={handleDescriptionChange} />
				<FieldPrice price={price} onChange={handlePriceChange} />
			</EditorFieldSection>
			<EditorFieldSection title="زمان و تصویر" description="تاریخ شروع و تصویر کاور">
				<FieldStart startDatetime={startDatetime} onChange={handleStartDatetimeChange} />
				<FieldImage onChange={handleImageChange} />
			</EditorFieldSection>
			<EditorFieldSection title="تخصص‌ها">
				<FieldExpertise onChange={handleExpertiseChange} isDesktop={isDesktop} />
			</EditorFieldSection>
		</EditorFormShell>
	);
}
